export default __webpack_public_path__ + "static/media/273.02060d0f.jpg";